// 接口文档： https://supptech.sg.larksuite.com/wiki/Nobsw0FhdilBpak9V2nlUc29gxh

import {
  ApproveParams,
  Artwork,
  ArtworkListResponse,
  ArtworkListSearchParams,
  BatchApproveParams,
  BatchApproveSelections,
  BatchRejectParams,
  BatchRejectSelections,
  Classification,
  RejectParams,
  RejectReason,
  ReviewHistoryParams,
  ReviewHistoryResponse,
  ReviewStatus,
} from '@/types/contentReview';
import axiosInstance from './axiosInstance';
import { BaseResponse } from '@/types/common';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

export const getArtworkList = async (params: ArtworkListSearchParams) => {
  const resp = await axiosInstance.post<BaseResponse<ArtworkListResponse>>(
    `${baseUrl}/review/list`,
    params
  );
  return resp.data;
};

export const getArtworkDetail = async (artworkId: string) => {
  const resp = await axiosInstance.get<BaseResponse<Artwork>>(
    `${baseUrl}/review/detail/${artworkId}`
  );
  return resp.data;
};

export const getReviewStatus = async (): Promise<
  BaseResponse<ReviewStatus[]>
> => {
  const resp = await axiosInstance.get<BaseResponse<ReviewStatus[]>>(
    `${baseUrl}/dict/review/status`
  );
  return resp.data;
};

export const getBatchApproveSelections = async (): Promise<
  BaseResponse<BatchApproveSelections[]>
> => {
  const resp = await axiosInstance.get<BaseResponse<BatchApproveSelections[]>>(
    `${baseUrl}/dict/batch/approve`
  );
  return resp.data;
};

export const getBatchRejectSelections = async () => {
  const resp = await axiosInstance.get<BaseResponse<BatchRejectSelections[]>>(
    `${baseUrl}/dict/batch/reject`
  );
  return resp.data;
};

export const getRejectReason = async (): Promise<
  BaseResponse<RejectReason[]>
> => {
  const resp = await axiosInstance.get<BaseResponse<RejectReason[]>>(
    `${baseUrl}/dict/reject/item`
  );
  return resp.data;
};

export const getReviewHistory = async (params: ReviewHistoryParams) => {
  const resp = await axiosInstance.post<BaseResponse<ReviewHistoryResponse>>(
    `${baseUrl}/review/operation/list`,
    params
  );
  return resp.data;
};

export const approveArtwork = async (params: ApproveParams) => {
  const resp = await axiosInstance.post<BaseResponse<null>>(
    `${baseUrl}/review/approve`,
    params
  );
  return resp.data;
};

export const rejectArtwork = async (params: RejectParams) => {
  const resp = await axiosInstance.post<BaseResponse<null>>(
    `${baseUrl}/review/reject`,
    params
  );
  return resp.data;
};

export const batchApproveArtwork = async (params: BatchApproveParams) => {
  const resp = await axiosInstance.post<BaseResponse<null>>(
    `${baseUrl}/review/batch/approve`,
    params
  );
  return resp.data;
};

export const batchRejectArtwork = async (params: BatchRejectParams) => {
  const resp = await axiosInstance.post<BaseResponse<null>>(
    `${baseUrl}/review/batch/reject`,
    params
  );
  return resp.data;
};

export const getClassifications = async (): Promise<
  BaseResponse<Classification[]>
> => {
  const resp = await axiosInstance.get<BaseResponse<Classification[]>>(
    `${baseUrl}/review/classify`
  );
  return resp.data;
};

export const getImproperList = async (params: ArtworkListSearchParams) => {
  // 分离 query 和 body 参数
  const { currentPage, pageSize, ...body } = params;
  const resp = await axiosInstance.post<BaseResponse<ArtworkListResponse>>(
    `${baseUrl}/v/v1/list?currentPage=${currentPage}&pageSize=${pageSize}`,
    body
  );
  return resp.data;
};

export const operateViolation = async (params: any) => {
  const resp = await axiosInstance.post<BaseResponse<ArtworkListResponse>>(
    `${baseUrl}/v/v1/operateViolation`,
    params
  );
  return resp.data;
};
